import { isEmpty } from 'lodash';
import {
    CONTACT_FIELD,
    CREDENTIAL_FIELD,
    CREDENTIAL_TIME_FIELD,
    DEVICE_MODEL_FIELD,
    LABEL_CONTACT,
    LABEL_CREDENTIAL_TIME,
    LABEL_DEVICE_MODEL,
    LABEL_DEVICE_TYPE,
    LABEL_IP_ADDRESS_NAME,
    LABEL_LOCATION,
    LABEL_MAC_ADDRESS,
    LABEL_OPERATING_SYSTEM,
    LABEL_SERIAL_NUMBER,
    LABEL_SYS_DESCRIPTION,
    LABEL_SYS_NAME,
    LABEL_UP_TIME,
    LABEL_WIRELESS_CONTROLLER,
    LOCATION_FIELD,
    MAC_ADDRESS_FIELD,
    OPERATING_SYSTEM_FIELD,
    SERIAL_NUMBER_FIELD,
    SYS_DESCRIPTION_FIELD,
    SYS_NAME_FIELD,
    VENDOR_FIELD,
} from './DeviceConstants';
import { LABEL_CREDENTIAL, LABEL_IP_ADDRESSES, LABEL_VENDOR } from '../InfrastructureConstants';
import { PropertiesGridFullWidth } from '../../../form/PropertiesGrid';
import { NgpLabelValue } from '../../../form/NgpLabelValue';
import WirelessControllerLink from './WirelessControllerLink';
import DeviceSites from './DeviceSites';
import PropertiesIpAddressList from '../../../properties/PropertiesIpAddressList';
import { EMPTY_VALUE, safeValue } from './DeviceDetailProperties';

const DeviceProperties = ({ properties, displayDeviceType, upTime, credentialTime }) => {
    return (
        <>
            <PropertiesGridFullWidth>
                <NgpLabelValue dataLabel={LABEL_SYS_NAME} dataValue={safeValue(properties[SYS_NAME_FIELD])} />
            </PropertiesGridFullWidth>
            <PropertiesGridFullWidth>
                <NgpLabelValue dataLabel={LABEL_IP_ADDRESS_NAME} dataValue={safeValue(properties.ipAddress)} />
            </PropertiesGridFullWidth>
            {properties.wirelessController && (
                <NgpLabelValue
                    dataLabel={LABEL_WIRELESS_CONTROLLER}
                    dataValue={<WirelessControllerLink controller={properties.wirelessController} />}
                />
            )}
            {properties[CREDENTIAL_FIELD] && (
                <NgpLabelValue dataLabel={LABEL_CREDENTIAL} dataValue={properties[CREDENTIAL_FIELD]} />
            )}
            {properties[CREDENTIAL_TIME_FIELD] && (
                <NgpLabelValue dataLabel={LABEL_CREDENTIAL_TIME} dataValue={credentialTime} />
            )}

            <NgpLabelValue dataLabel={LABEL_DEVICE_TYPE} dataValue={displayDeviceType} />
            <NgpLabelValue dataLabel={LABEL_DEVICE_MODEL} dataValue={safeValue(properties[DEVICE_MODEL_FIELD])} />
            <NgpLabelValue dataLabel={LABEL_VENDOR} dataValue={safeValue(properties[VENDOR_FIELD])} />
            <NgpLabelValue
                dataLabel={LABEL_OPERATING_SYSTEM}
                dataValue={safeValue(properties[OPERATING_SYSTEM_FIELD])}
            />
            <NgpLabelValue dataLabel={LABEL_UP_TIME} dataValue={upTime} />
            <NgpLabelValue dataLabel={LABEL_CONTACT} dataValue={safeValue(properties[CONTACT_FIELD])} />
            <NgpLabelValue dataLabel={LABEL_MAC_ADDRESS} dataValue={safeValue(properties[MAC_ADDRESS_FIELD])} />
            <NgpLabelValue dataLabel={LABEL_SERIAL_NUMBER} dataValue={safeValue(properties[SERIAL_NUMBER_FIELD])} />
            <NgpLabelValue dataLabel={LABEL_LOCATION} dataValue={safeValue(properties[LOCATION_FIELD])} />
            <PropertiesGridFullWidth>
                <NgpLabelValue
                    dataLabel={LABEL_SYS_DESCRIPTION}
                    dataValue={safeValue(properties[SYS_DESCRIPTION_FIELD])}
                    wrap
                />
            </PropertiesGridFullWidth>
            <DeviceSites deviceIpAddress={properties.deviceIpAddress} sites={properties.sites} />
            <NgpLabelValue
                dataLabel={LABEL_IP_ADDRESSES}
                dataValue={
                    isEmpty(properties.ipAddresses) ? (
                        EMPTY_VALUE
                    ) : (
                        <PropertiesIpAddressList value={properties.ipAddresses} />
                    )
                }
            />
        </>
    );
};

export default DeviceProperties;
